// frontend/src/components/common/ConfidentialityNotice.jsx
import React from "react";

const ConfidentialityNotice = ({ className = "" }) => {
  return (
    <div
      className={`alert alert-warning d-flex align-items-center mb-3 ${className}`}
      role="alert"
    >
      <i
        className="bi bi-exclamation-triangle-fill me-2"
        aria-hidden="true"
      ></i>
      <div>
        <strong>Confidentiality Notice:</strong> The information displayed below
        contains Protected Health Information. Do not share, photograph, or
        discuss this information outside of authorized purposes. All access is
        being logged.
      </div>
    </div>
  );
};

export default ConfidentialityNotice;
